import axios from "axios";

export const fetchUpdateTaskCounterTemplate = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.put(`${baseTaskUrl}/TaskCounterTemplate/${data.id}`, data);
};
